// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";

// const ChangePasswordPage = () => {
//   const navigate = useNavigate();

//   const [newPassword, setNewPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [error, setError] = useState("");

//   const userId = localStorage.getItem("forcePasswordUserId");

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     setError("");

//     if (newPassword.length < 6) {
//       setError("Password must be at least 6 characters.");
//       return;
//     }

//     if (newPassword !== confirmPassword) {
//       setError("Passwords do not match.");
//       return;
//     }

//     try {
//       const response = await fetch(
//         "/api/auth/change-password",
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({
//             userId,
//             newPassword,
//           }),
//         }
//       );

//       const data = await response.json();

//       if (!response.ok) {
//         throw new Error(data.message);
//       }

//       localStorage.removeItem("forcePasswordUserId");

//       alert("Password changed successfully. Please login again.");

//       navigate("/login");

//     } catch (err) {
//       setError(err.message || "Failed to change password");
//     }
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center">
//       <div className="bg-white p-8 shadow rounded w-full max-w-md">
//         <h2 className="text-2xl font-bold mb-6">
//           Change Password
//         </h2>

//         {error && (
//           <div className="mb-4 text-red-600">
//             {error}
//           </div>
//         )}

//         <form onSubmit={handleSubmit}>
//           <input
//             type="password"
//             placeholder="New Password"
//             value={newPassword}
//             onChange={(e) =>
//               setNewPassword(e.target.value)
//             }
//             className="w-full border p-2 mb-4"
//           />

//           <input
//             type="password"
//             placeholder="Confirm Password"
//             value={confirmPassword}
//             onChange={(e) =>
//               setConfirmPassword(e.target.value)
//             }
//             className="w-full border p-2 mb-4"
//           />

//           <button
//             type="submit"
//             className="w-full bg-blue-600 text-white p-2 rounded"
//           >
//             Change Password
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ChangePasswordPage;



import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const ChangePasswordPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  // Get user ID from temporary localStorage
  // or from navigation state
  const userId =
    localStorage.getItem("forcePasswordUserId") ||
    location.state?.userId;

  // Get temporary authentication token
  const token =
    localStorage.getItem("forcePasswordToken");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError("");

    // =================================================
    // VALIDATION
    // =================================================

    if (!userId) {
      setError(
        "User information is missing. Please login again."
      );
      return;
    }

    if (!token) {
      setError(
        "Authentication token is missing. Please login again."
      );
      return;
    }

    if (newPassword.length < 6) {
      setError(
        "Password must be at least 6 characters."
      );
      return;
    }

    if (newPassword !== confirmPassword) {
      setError(
        "Passwords do not match."
      );
      return;
    }

    // =================================================
    // CHANGE PASSWORD
    // =================================================

    try {
      const response = await fetch(
        "/api/auth/change-password",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",

            // IMPORTANT
            Authorization: `Bearer ${token}`,
          },

          credentials: "include",

          body: JSON.stringify({
            userId,
            newPassword,
          }),
        }
      );

     const responseText = await response.text();

console.log("====================================");
console.log("CHANGE PASSWORD RESPONSE");
console.log("Status:", response.status);
console.log("OK:", response.ok);
console.log("Raw Response:", responseText);
console.log("====================================");

let data;

try {
  data = responseText
    ? JSON.parse(responseText)
    : {};
} catch (parseError) {
  throw new Error(
    `Server returned invalid response (HTTP ${response.status})`
  );
}

if (!response.ok) {
  throw new Error(
    data.message ||
    `Change password failed (HTTP ${response.status})`
  );
}
      if (!response.ok) {
        throw new Error(
          data.message ||
          "Failed to change password"
        );
      }

      // =================================================
      // SUCCESS
      // =================================================

      localStorage.removeItem(
        "forcePasswordUserId"
      );

      localStorage.removeItem(
        "forcePasswordToken"
      );

      alert(
        "Password changed successfully. Please login again."
      );

      navigate("/login");

    } catch (err) {

      console.error(
        "Change Password Error:",
        err
      );

      setError(
        err.message ||
        "Failed to change password"
      );
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="bg-white p-8 shadow rounded w-full max-w-md">

        <h2 className="text-2xl font-bold mb-6">
          Change Password
        </h2>

        {error && (
          <div className="mb-4 text-red-600">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>

          <input
            type="password"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) =>
              setNewPassword(e.target.value)
            }
            className="w-full border p-2 mb-4"
            autoComplete="new-password"
          />

          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) =>
              setConfirmPassword(e.target.value)
            }
            className="w-full border p-2 mb-4"
            autoComplete="new-password"
          />

          <button
            type="submit"
            className="w-full bg-blue-600 text-white p-2 rounded"
          >
            Change Password
          </button>

        </form>
      </div>
    </div>
  );
};

export default ChangePasswordPage;